import React, { useEffect, useRef, useState } from "react";
import { Spin, Table } from "antd";
import CoinStatusIndicator from "../commoncomponent/CoinStatusIndicator";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link, useHistory } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InputLabel from "@mui/material/InputLabel";
import { Button, Menu, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import { HiDotsVertical } from "react-icons/hi";
import {
    addTradingPair,
    deleteTradingPair,
    editTradingPair,
    getCategory,
    getCoin,
    getTradingPair,
    getTradingPairById,
    syncCoindcxPrecision,
    toggleStopBuy,
    toggleStopSell,
    toggleStopAll,
    toggleIsEnabled,
    toggleInternalization,
} from "../../../service/api";
import { io } from "socket.io-client";
import { ORDER_URL } from "../../../config";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import actions from "../../../redux/user/actions";
import { FaArrowLeft } from "react-icons/fa";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import ReactSelect from "react-select";
import { sanitizeInput, decryptString } from "../../../config/validation";
import moment from "moment";
import { triggerDownload } from "../../../config/downloadUtils";

const formatDate = (val) => (val ? moment(val).format("DD/MM/YYYY") : "-");

const ORDER_TYPE_DEFS = [
    { value: "market_order",      label: "Market Order" },
    { value: "limit_order",       label: "Limit Order" },
    { value: "stop_limit_order",  label: "Stop Limit Order" },
    { value: "stop_market_order", label: "Stop Market Order" },
    { value: "oco_market",        label: "OCO Market" },
    { value: "oco_limit",         label: "OCO Limit" },
];

const DEFAULT_ORDER_TYPE_CONTROLS = ORDER_TYPE_DEFS.reduce((acc, ot) => {
    acc[ot.value] = { buy: true, sell: true };
    return acc;
}, {});

// Merge a partial/absent server value with full-enabled defaults so the form
// always renders all 6 rows regardless of what the backend returns.
const normalizeOrderTypeControls = (value) => {
    const merged = { ...DEFAULT_ORDER_TYPE_CONTROLS };
    if (value && typeof value === "object") {
        for (const key of Object.keys(merged)) {
            if (value[key]) {
                merged[key] = {
                    buy: value[key].buy !== false,
                    sell: value[key].sell !== false,
                };
            }
        }
    }
    return merged;
};

const InfoIcon = ({ title }) => (
    <Tooltip title={title} arrow placement="top">
        <span
            style={{
                cursor: "help",
                marginLeft: 6,
                color: "#1677ff",
                fontSize: 11,
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #1677ff",
                borderRadius: "50%",
                width: 14,
                height: 14,
                lineHeight: 1,
                verticalAlign: "middle",
                flexShrink: 0,
            }}
        >
            i
        </span>
    </Tooltip>
);

const ALL_COLUMNS = [
    {
        key: "fromCoin",
        title: "From Coin",
        defaultVisible: true,
        render: (r) => (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {r?.fromCoin?.image && (
                    <img
                        src={r.fromCoin.image}
                        alt={r.fromCoin.name || ""}
                        style={{ width: 24, height: 24, borderRadius: "50%", objectFit: "contain" }}
                        onError={(e) => { e.target.style.display = "none"; }}
                    />
                )}
                <span>{r?.fromCoin?.name || "-"}</span>
            </div>
        ),
    },
    {
        key: "fromCoinDW",
        title: "From D/W",
        defaultVisible: true,
        render: (r) => (
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <CoinStatusIndicator
                    coin={r?.fromCoin}
                    networks={r?.fromCoin?.networks || []}
                    flow="deposit"
                />
                <CoinStatusIndicator
                    coin={r?.fromCoin}
                    networks={r?.fromCoin?.networks || []}
                    flow="withdraw"
                />
            </div>
        ),
    },
    {
        key: "toCoin",
        title: "To Coin",
        defaultVisible: true,
        render: (r) => (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {r?.toCoin?.image && (
                    <img
                        src={r.toCoin.image}
                        alt={r.toCoin.name || ""}
                        style={{ width: 24, height: 24, borderRadius: "50%", objectFit: "contain" }}
                        onError={(e) => { e.target.style.display = "none"; }}
                    />
                )}
                <span>{r?.toCoin?.name || "-"}</span>
            </div>
        ),
    },
    {
        key: "toCoinDW",
        title: "To D/W",
        defaultVisible: false,
        render: (r) => (
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <CoinStatusIndicator
                    coin={r?.toCoin}
                    networks={r?.toCoin?.networks || []}
                    flow="deposit"
                />
                <CoinStatusIndicator
                    coin={r?.toCoin}
                    networks={r?.toCoin?.networks || []}
                    flow="withdraw"
                />
            </div>
        ),
    },
    {
        key: "pair",
        title: "Pair",
        defaultVisible: false,
        render: (r) =>
            r?.fromCoin?.symbol && r?.toCoin?.symbol
                ? `${r.fromCoin.symbol}/${r.toCoin.symbol}`
                : "-",
    },
    {
        key: "pairType",
        title: "Type",
        defaultVisible: true,
        render: (r) => {
            if (r?.type === "custom") return (
                <span style={{ background: "#dbeafe", color: "#1d4ed8", fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 10 }}>
                    Custom
                </span>
            );
            if (r?.type === "kucoin") return (
                <span style={{ background: "#f3f4f6", color: "#374151", fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 10 }}>
                    KuCoin
                </span>
            );
            return null;
        },
    },
    {
        key: "currentPrice",
        title: "Current Price",
        defaultVisible: true,
        render: (r) =>
            r?.currentPrice !== undefined && r?.currentPrice !== null ? (
                <span style={{ fontWeight: 600, color: "#1a7a4a", fontVariantNumeric: "tabular-nums" }}>
                    {r.currentPrice}
                </span>
            ) : (
                <span style={{ color: "#bfbfbf" }}>—</span>
            ),
    },
    {
        key: "category",
        title: "Category",
        defaultVisible: false,
        render: (r) =>
            r?.pairCategoryData && r.pairCategoryData.length > 0
                ? r.pairCategoryData.map((c) => c?.name).join(", ")
                : "-",
    },
    {
        key: "status",
        title: "Status",
        defaultVisible: false,
        render: (r) =>
            r?.status === 0
                ? "Inactive"
                : r?.status === 1
                  ? "Active"
                  : r?.status !== undefined
                    ? String(r.status)
                    : "-",
    },
    {
        key: "buySellStatus",
        title: "Buy / Sell Status",
        defaultVisible: true,
        render: (r) => {
            const pillStyle = (stopped) => ({
                display: "inline-block",
                padding: "2px 8px",
                borderRadius: 12,
                fontSize: 11,
                fontWeight: 600,
                color: stopped ? "#b91c1c" : "#15803d",
                backgroundColor: stopped ? "#fee2e2" : "#dcfce7",
                border: `1px solid ${stopped ? "#fecaca" : "#bbf7d0"}`,
                marginRight: 4,
            });
            // Internal-matching pill: green when ON, grey when OFF. Not shown for
            // custom-token pairs (those are always internal by definition).
            const internalOn = !!r?.internalizationEnabled;
            const internalPillStyle = {
                display: "inline-block",
                padding: "2px 8px",
                borderRadius: 12,
                fontSize: 11,
                fontWeight: 600,
                color: internalOn ? "#15803d" : "#6b7280",
                backgroundColor: internalOn ? "#dcfce7" : "#f3f4f6",
                border: `1px solid ${internalOn ? "#bbf7d0" : "#e5e7eb"}`,
                marginRight: 4,
            };
            return (
                <span>
                    <span style={pillStyle(!!r?.stopBuy)}>
                        Buy: {r?.stopBuy ? "Stopped" : "Active"}
                    </span>
                    <span style={pillStyle(!!r?.stopSell)}>
                        Sell: {r?.stopSell ? "Stopped" : "Active"}
                    </span>
                    {r?.type !== "custom" ? (
                        <span style={internalPillStyle}>
                            Internal: {internalOn ? "On" : "Off"}
                        </span>
                    ) : null}
                </span>
            );
        },
    },
    {
        key: "orderTypeSupport",
        title: "Order Types",
        defaultVisible: false,
        render: (r) => {
            const controls = r?.orderTypeControls;
            if (!controls || typeof controls !== "object") return "6/6 (default)";
            const enabledCount = ORDER_TYPE_DEFS.filter(
                (ot) => controls[ot.value]?.buy !== false || controls[ot.value]?.sell !== false
            ).length;
            return `${enabledCount}/6 enabled`;
        },
    },
    {
        key: "createdAt",
        title: "Date",
        defaultVisible: true,
        render: (r) => formatDate(r?.updatedAt || r?.createdAt),
    },
];

const customStyles = {
    control: (base) => ({
        ...base,
        minHeight: "38px",
        height: "40px",
        width: "200px",
        minWidth: "120px",
        borderRadius: "4px",
        border: "1px solid #ced4da",
        fontSize: "14px",
        padding: "0px 4px",
        backgroundColor: "#fff",
    }),
    dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
    indicatorSeparator: () => ({ display: "none" }),
};

const styleDelete = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 290,
    background: "white",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
    outline: "none",
};

const TradingPair = () => {
    const history = useHistory();
    const [roleInput, setroleInput] = useState({
        fromCoin: "",
        toCoin: "",
        currentPrice: "",
        minTradeAmount: "",
        maxTradeAmount: "",
        basePrecision: "",
        targetPrecision: "",
        minNotional: "",
        stepSize: "",
        priceSpread: "",
        isEnabled: true,
        precisionManualOverride: false,
        resyncFromCoinDcx: false,
        precisionLastSyncedAt: null,
        pairCategory: [],
        type: "coindcx",
        orderTypes: ["limit_order", "market_order"],
        orderTypeControls: DEFAULT_ORDER_TYPE_CONTROLS,
    });
    //
    const [roleInputError, setroleInputError] = useState({
        fromCoin: false,
        toCoin: false,
        currentPrice: false,
        minTradeAmount: false,
        maxTradeAmount: false,
        basePrecision: false,
        targetPrecision: false,
        minNotional: false,
        stepSize: false,
        priceSpread: false,
        pairCategory: false,
    });
    const [userList, setUserlist] = useState([]);
    const [coinList, setCoinList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);

    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);
    const handleMenuOpen = (event, row) => { setId(row); setAnchorEl(event.currentTarget); };
    const handleMenuClose = () => setAnchorEl(null);

    const [user, setUser] = useState(false);
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [syncLoading, setSyncLoading] = useState(false);
    const [edit, setEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const handleOpenDelete = () => setOpenDelete(true);
    const handleCloseDelete = () => setOpenDelete(false);
    const [id, setId] = useState(false);
    const dispatch = useDispatch();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterFromCoin, setFilterFromCoin] = useState(null);
    const [filterToCoin, setFilterToCoin] = useState(null);
    const [filterCategory, setFilterCategory] = useState(null);
    const [filterIsEnabled, setFilterIsEnabled] = useState(null);
    const [priceLoading, setPriceLoading] = useState(false);
    const socketRef = useRef(null);
    const [openStatusConfirm, setOpenStatusConfirm] = useState(false);
    const [pendingStatus, setPendingStatus] = useState(null); // { id, status }
    const [statusLoading, setStatusLoading] = useState(false);
    const [stopBuyLoadingId,  setStopBuyLoadingId]  = useState(null);
    const [stopSellLoadingId, setStopSellLoadingId] = useState(null);
    const [stopAllLoadingId,  setStopAllLoadingId]  = useState(null);
    const [isEnabledLoadingId, setIsEnabledLoadingId] = useState(null);
    const [internalizationLoadingId, setInternalizationLoadingId] = useState(null);

    const {
        pageSize,
        setPageSize,
        pageSizeOptions,
        visibleColumnKeys,
        toggleColumn,
        resetColumns,
        dynamicColumns,
    } = useTableSettings({
        storageKey: "trading-pair-list",
        allColumns: ALL_COLUMNS,
    });
    const roleChange = (e) => {
        const { name, value } = e.target;
        if (e.target.type === "number") {
            if (value >= 0) {
                setroleInput({ ...roleInput, [name]: sanitizeInput(value) });
            }
        } else {
            setroleInput({ ...roleInput, [name]: sanitizeInput(value) });
        }
        setroleInputError({ ...roleInputError, [name]: false });
    };

    const getUserList = () => {
        let body = {
            page: page,
            sizePerPage: pageSize,
            pagination: true,
        };
        if (startDate) {
            body.startDate = startDate;
        }
        if (endDate) {
            body.endDate = endDate;
        }
        if (filterFromCoin) {
            body.fromCoin = filterFromCoin?.value;
        }
        if (filterToCoin) {
            body.toCoin = filterToCoin?.value;
        }
        if (filterCategory) {
            body.pairCategory = filterCategory?.value;
        }
        if (filterIsEnabled) {
            body.isEnabled = filterIsEnabled.value;
        }
        if (searchTerm) {
            body.search = searchTerm;
        }
        setLoading(true);
        getTradingPair(body)
            .then((res) => {
                if (res?.status) {
                    setUserlist(res?.data);
                }
                setLoading(false);
            })
            .finally((res) => {
                setLoading(false);
            });
    };

    const getCoinList = () => {
        let body = {
            page: page,
            sizePerPage: 10,
            pagination: false,
        };

        // setLoading(true);
        getCoin(body).then((res) => {
            if (res?.status) {
                setCoinList(res?.data?.result);
            }
        });
    };
    const getCategoryList = () => {
        let body = {
            //  page: page,
            //  sizePerPage: 10,
            pagination: false,
        };

        // setLoading(true);
        getCategory(body).then((res) => {
            if (res?.status) {
                setCategoryList(res?.data?.result);
            }
        });
    };
    const handleDownload = (format) => {
        const body = { pagination: false };
        if (startDate) body.startDate = startDate;
        if (endDate) body.endDate = endDate;
        if (filterFromCoin) body.fromCoin = filterFromCoin?.value;
        if (filterToCoin) body.toCoin = filterToCoin?.value;
        if (filterCategory) body.pairCategory = filterCategory?.value;
        if (searchTerm) body.search = searchTerm;
        setDownloadLoading(true);
        getTradingPair(body)
            .then((res) => {
                const result = res?.data?.result ?? [];
                if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
                const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
                triggerDownload(format, result, cols, "trading-pairs");
            })
            .finally(() => setDownloadLoading(false));
    };

    const handleClear = () => {
        setroleInput({
            ...roleInput,
            fromCoin: "",
            toCoin: "",
            currentPrice: "",
            minTradeAmount: "",
            maxTradeAmount: "",
            basePrecision: "",
            targetPrecision: "",
            minNotional: "",
            stepSize: "",
            priceSpread: "",
            isEnabled: true,
            precisionManualOverride: false,
            resyncFromCoinDcx: false,
            precisionLastSyncedAt: null,
            pairCategory: [],
            type: "coindcx",
            orderTypes: ["limit_order", "market_order"],
            orderTypeControls: DEFAULT_ORDER_TYPE_CONTROLS,
        });
        setroleInputError({
            fromCoin: false,
            toCoin: false,
            currentPrice: false,
            minTradeAmount: false,
            maxTradeAmount: false,
            basePrecision: false,
            targetPrecision: false,
            minNotional: false,
            stepSize: false,
            priceSpread: false,
            pairCategory: false,
        });
    };
    // ADD USER FUNCTION
    const addUserFun = async () => {
        if (
            !roleInput?.fromCoin &&
            !roleInput?.toCoin &&
            !roleInput?.currentPrice
            // !roleInput?.maxTradeAmount &&
            // !roleInput?.minTradeAmount
        ) {
            setroleInputError({
                ...roleInputError,
                fromCoin: true,
                toCoin: true,
                currentPrice: true,
                // minTradeAmount: true,
                // maxTradeAmount: true,
            });
            return;
        } else if (!roleInput?.fromCoin) {
            setroleInputError({ ...roleInputError, fromCoin: true });
            return;
        } else if (!roleInput?.toCoin) {
            setroleInputError({ ...roleInputError, toCoin: true });
            return;
        } else if (roleInput?.pairCategory?.length === 0) {
            setroleInputError({ ...roleInputError, pairCategory: true });
            return;
        } else if (!roleInput?.currentPrice) {
            setroleInputError({ ...roleInputError, currentPrice: true });
            return;
        } else if (roleInput?.priceSpread !== "" && roleInput?.priceSpread !== undefined && Number(roleInput.priceSpread) < 0.5) {
            setroleInputError({ ...roleInputError, priceSpread: true });
            toast.error("Price spread must be at least 0.5", { toastId: 'trading-pair-validation-error' });
            return;
        }
        //  else if (!roleInput?.maxTradeAmount) {
        //   setroleInputError({ ...roleInputError, maxTradeAmount: true });
        //   return;
        // } else if (!roleInput?.minTradeAmount) {
        //   setroleInputError({ ...roleInputError, minTradeAmount: true });
        //   return;
        // } else if (+roleInput?.maxTradeAmount < +roleInput?.minTradeAmount) {
        //   toast.warn("Max trade amount cannot be smaller than min trade amount");
        //   return;
        // }
        if (roleInput) {
            setLoading(true);
            if (!edit) {
                // Create plain object with data to encrypt
                const isCustom = roleInput?.type === "custom";
                const plainData = {
                    currentPrice: sanitizeInput(roleInput?.currentPrice),
                    toCoin: roleInput?.toCoin,
                    fromCoin: roleInput?.fromCoin,
                    pairCategory: roleInput?.pairCategory?.filter(
                        (c) => typeof c === "string" && c,
                    ),
                    isEnabled: roleInput?.isEnabled !== false,
                    type: roleInput?.type || "coindcx",
                    ...(isCustom && { orderTypes: roleInput?.orderTypes || ["limit_order", "market_order"] }),
                    orderTypeControls: roleInput?.orderTypeControls || DEFAULT_ORDER_TYPE_CONTROLS,
                    ...(roleInput?.minTradeAmount !== "" && roleInput?.minTradeAmount !== undefined && { minTradeAmount: Number(roleInput.minTradeAmount) }),
                    ...(roleInput?.maxTradeAmount !== "" && roleInput?.maxTradeAmount !== undefined && { maxTradeAmount: Number(roleInput.maxTradeAmount) }),
                    ...(roleInput?.basePrecision !== "" && { basePrecision: Number(roleInput.basePrecision) }),
                    ...(roleInput?.targetPrecision !== "" && { targetPrecision: Number(roleInput.targetPrecision) }),
                    ...(roleInput?.minNotional !== "" && { minNotional: roleInput.minNotional }),
                    ...(roleInput?.stepSize !== "" && { stepSize: roleInput.stepSize }),
                    ...(!isCustom && roleInput?.priceSpread !== "" && roleInput?.priceSpread !== undefined && { priceSpread: Number(roleInput.priceSpread) }),
                };

                // Encrypt the plain object
                const encryptedData = await decryptString(plainData);

                // Send encrypted data
                const payload = { encrypt: encryptedData };
                addTradingPair(payload)
                    .then((res) => {
                        if (res?.status) {
                            toast.success(res?.message, { toastId: 'trading-pair-add-success' });
                            setUser(false);
                            getUserList();
                            handleClear();
                        } else {
                            toast.error(res?.message, { toastId: 'trading-pair-add-error' });
                        }
                    })
                    .catch((err) => {
                        toast.error(err?.response?.data?.message, { toastId: 'trading-pair-add-error' });
                    })
                    .finally((res) => {
                        setLoading(false);
                    });
            } else {
                // Create plain object with data to encrypt
                const isCustomEdit = roleInput?.type === "custom";
                const plainData = {
                    currentPrice: sanitizeInput(roleInput?.currentPrice),
                    toCoin: roleInput?.toCoin,
                    fromCoin: roleInput?.fromCoin,
                    pairCategory: roleInput?.pairCategory?.filter(
                        (c) => typeof c === "string" && c,
                    ),
                    isEnabled: roleInput?.isEnabled !== false,
                    ...(isCustomEdit && { orderTypes: roleInput?.orderTypes || ["limit_order", "market_order"] }),
                    orderTypeControls: roleInput?.orderTypeControls || DEFAULT_ORDER_TYPE_CONTROLS,
                    ...(roleInput?.minTradeAmount !== "" && roleInput?.minTradeAmount !== undefined && { minTradeAmount: Number(roleInput.minTradeAmount) }),
                    ...(roleInput?.maxTradeAmount !== "" && roleInput?.maxTradeAmount !== undefined && { maxTradeAmount: Number(roleInput.maxTradeAmount) }),
                    ...(roleInput?.basePrecision !== "" && { basePrecision: Number(roleInput.basePrecision) }),
                    ...(roleInput?.targetPrecision !== "" && { targetPrecision: Number(roleInput.targetPrecision) }),
                    ...(roleInput?.minNotional !== "" && { minNotional: roleInput.minNotional }),
                    ...(roleInput?.stepSize !== "" && { stepSize: roleInput.stepSize }),
                    ...(!isCustomEdit && roleInput?.priceSpread !== "" && roleInput?.priceSpread !== undefined && { priceSpread: Number(roleInput.priceSpread) }),
                    ...(roleInput?.resyncFromCoinDcx === true && { clearManualOverride: true }),
                };

                // Encrypt the plain object
                const encryptedData = await decryptString(plainData);

                // Send encrypted data
                const payload = { encrypt: encryptedData };
                editTradingPair(id?._id, payload)
                    .then((res) => {
                        if (res?.status) {
                            toast.success(res?.message, { toastId: 'trading-pair-update-success' });
                            setEdit(false);
                            setUser(false);
                            getUserList();
                            handleClear();
                        } else {
                            toast.error(res?.message, { toastId: 'trading-pair-update-error' });
                        }
                    })
                    .catch((err) => {
                        toast.error(err?.response?.data?.message, { toastId: 'trading-pair-update-error' });
                    })
                    .finally((res) => {
                        setLoading(false);
                    });
            }
        }
    };
    // DELETE USER FUNCTION

    const handleDeleteFunction = () => {
        setLoading(true);
        deleteTradingPair(id?._id)
            .then((res) => {
                if (res?.status) {
                    toast.success(res?.message, { toastId: 'trading-pair-delete-success' });
                    handleCloseDelete();
                    getUserList();
                    setId(null);
                } else {
                    toast.error(res?.message, { toastId: 'trading-pair-delete-error' });
                }
            })
            .catch((e) => {
                setLoading(false);
                toast.error(e?.response?.data?.message, { toastId: 'trading-pair-delete-error' });
            })
            .finally((res) => {
                setLoading(false);
            });
    };
    // Effect 1: connect once on mount, update table prices globally
    // TODO(monorepo-migration): Backend-Monorepo's api-gateway is HTTP-only
    // — it does not proxy socket.io. The live `priceData` stream will not
    // work against the new backend until either the gateway adds WS support
    // or this connects directly to whichever service owns the price feed.
    useEffect(() => {
        console.log("[TradingPair] Connecting to socket:", ORDER_URL);
        socketRef.current = io(ORDER_URL, {
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            transports: ["polling", "websocket"],
            timeout: 10000,
        });

        socketRef.current.on("connect", () => {
            console.log("[TradingPair] Socket connected, id:", socketRef.current?.id);
        });

        socketRef.current.on("priceData", (data) => {
            console.log("[TradingPair] priceData received:", data);
            if (!data?.pair) return;
            setUserlist((prev) => {
                if (!prev?.result) return prev;
                const updated = prev.result.map((item) =>
                    String(item._id) === String(data.pair)
                        ? { ...item, currentPrice: data.c }
                        : item,
                );
                const matched = updated.some(
                    (item) => String(item._id) === String(data.pair),
                );
                if (!matched) {
                    console.warn("[TradingPair] priceData pair not found in list:", data.pair);
                }
                return { ...prev, result: updated };
            });
        });

        socketRef.current.on("connect_error", (err) => {
            console.error("[TradingPair] Socket connect_error:", err);
        });

        socketRef.current.on("disconnect", (reason) => {
            console.warn("[TradingPair] Socket disconnected:", reason);
        });

        return () => {
            if (socketRef.current) {
                socketRef.current.off("connect");
                socketRef.current.off("priceData");
                socketRef.current.off("connect_error");
                socketRef.current.off("disconnect");
                socketRef.current.disconnect();
                socketRef.current = null;
            }
        };
    }, []);

    // Effect 2: when editing a pair, auto-update currentPrice in the form
    useEffect(() => {
        if (!socketRef.current || !id?._id) return;

        const handlePrice = (data) => {
            if (String(data?.pair) === String(id._id)) {
                console.log("[TradingPair] Edit form price update:", data.c, "for pair:", id._id);
                setroleInput((prev) => ({ ...prev, currentPrice: +data.c }));
            }
        };

        socketRef.current.on("priceData", handlePrice);
        return () => {
            socketRef.current?.off("priceData", handlePrice);
        };
    }, [id?._id]);

    const handleToggleStopBuy = async (row) => {
        if (!row?._id || stopBuyLoadingId) return;
        setStopBuyLoadingId(row._id);
        try {
            const res = await toggleStopBuy(row._id);
            res?.status ? toast.success(res.message, { toastId: 'trading-pair-status-success' }) : toast.error(res.message, { toastId: 'trading-pair-status-error' });
        } catch (e) {
            toast.error(e?.response?.data?.message || "Something went wrong", { toastId: 'trading-pair-status-error' });
        } finally {
            setStopBuyLoadingId(null);
            getUserList();
        }
    };

    const handleToggleStopSell = async (row) => {
        if (!row?._id || stopSellLoadingId) return;
        setStopSellLoadingId(row._id);
        try {
            const res = await toggleStopSell(row._id);
            res?.status ? toast.success(res.message, { toastId: 'trading-pair-status-success' }) : toast.error(res.message, { toastId: 'trading-pair-status-error' });
        } catch (e) {
            toast.error(e?.response?.data?.message || "Something went wrong", { toastId: 'trading-pair-status-error' });
        } finally {
            setStopSellLoadingId(null);
            getUserList();
        }
    };

    const handleToggleStopAll = async (row) => {
        if (!row?._id || stopAllLoadingId) return;
        setStopAllLoadingId(row._id);
        try {
            const res = await toggleStopAll(row._id);
            res?.status ? toast.success(res.message, { toastId: 'trading-pair-status-success' }) : toast.error(res.message, { toastId: 'trading-pair-status-error' });
        } catch (e) {
            toast.error(e?.response?.data?.message || "Something went wrong", { toastId: 'trading-pair-status-error' });
        } finally {
            setStopAllLoadingId(null);
            getUserList();
        }
    };

    const handleToggleIsEnabled = async (row) => {
        if (!row?._id || isEnabledLoadingId) return;
        setIsEnabledLoadingId(row._id);
        try {
            const res = await toggleIsEnabled(row._id);
            res?.status ? toast.success(res.message, { toastId: 'trading-pair-enabled-success' }) : toast.error(res.message, { toastId: 'trading-pair-enabled-error' });
        } catch (e) {
            toast.error(e?.response?.data?.message || "Something went wrong", { toastId: 'trading-pair-enabled-error' });
        } finally {
            setIsEnabledLoadingId(null);
            getUserList();
        }
    };

    const handleToggleInternalization = async (row) => {
        if (!row?._id || internalizationLoadingId) return;
        setInternalizationLoadingId(row._id);
        try {
            const res = await toggleInternalization(row._id);
            res?.status ? toast.success(res.message, { toastId: 'trading-pair-internalization-success' }) : toast.error(res.message, { toastId: 'trading-pair-internalization-error' });
        } catch (e) {
            toast.error(e?.response?.data?.message || "Something went wrong", { toastId: 'trading-pair-internalization-error' });
        } finally {
            setInternalizationLoadingId(null);
            getUserList();
        }
    };

    const handleStatusConfirm = async () => {
        if (!pendingStatus) return;
        setStatusLoading(true);
        try {
            const encryptedData = await decryptString({ status: pendingStatus.status });
            const payload = { encrypt: encryptedData };
            const res = await editTradingPair(pendingStatus.id, payload);
            if (res?.status) {
                toast.success(res?.message, { toastId: 'trading-pair-status-success' });
                getUserList();
            } else {
                toast.error(res?.message, { toastId: 'trading-pair-status-error' });
            }
        } catch (e) {
            toast.error(e?.response?.data?.message || "Something went wrong", { toastId: 'trading-pair-status-error' });
        } finally {
            setStatusLoading(false);
            setOpenStatusConfirm(false);
            setPendingStatus(null);
        }
    };

    useEffect(() => {
        getUserList();
    }, [
        page,
        pageSize,
        startDate,
        endDate,
        filterFromCoin,
        filterToCoin,
        filterCategory,
        filterIsEnabled,
        searchTerm,
    ]);

    // Reset to page 1 whenever filters or page size change.
    useEffect(() => {
        setPage(1);
    }, [
        pageSize,
        startDate,
        endDate,
        filterFromCoin,
        filterToCoin,
        filterCategory,
        filterIsEnabled,
        searchTerm,
    ]);

    useEffect(() => {
        getCoinList();
        getCategoryList();
    }, []);

    const getUserDataById = (id) => {
        getTradingPairById(id)
            ?.then((res) => {
                if (res?.status) {
                    let data = res?.data;
                    const fromCoinId =
                        typeof data?.fromCoin === "object"
                            ? data?.fromCoin?._id
                            : data?.fromCoin;
                    const toCoinId =
                        typeof data?.toCoin === "object"
                            ? data?.toCoin?._id
                            : data?.toCoin;
                    const pairCategoryIds = (
                        data?.pairCategoryData?.length
                            ? data.pairCategoryData
                            : data?.pairCategory || []
                    )
                        .map((c) => (typeof c === "object" ? c?._id : c))
                        .filter(Boolean);
                    setroleInput((prev) => ({
                        ...prev,
                        currentPrice: data?.currentPrice ?? "",
                        minTradeAmount: data?.minTradeAmount ?? "",
                        maxTradeAmount: data?.maxTradeAmount ?? "",
                        basePrecision: data?.basePrecision ?? "",
                        targetPrecision: data?.targetPrecision ?? "",
                        minNotional: data?.minNotional ?? "",
                        stepSize: data?.stepSize ?? "",
                        priceSpread: data?.priceSpread ?? "",
                        isEnabled: data?.isEnabled !== false,
                        precisionManualOverride: !!data?.precisionManualOverride,
                        resyncFromCoinDcx: false,
                        precisionLastSyncedAt: data?.precisionLastSyncedAt ?? null,
                        toCoin: toCoinId || "",
                        fromCoin: fromCoinId || "",
                        pairCategory: pairCategoryIds,
                        type: data?.type || "coindcx",
                        orderTypes: data?.orderTypes?.length ? data.orderTypes : ["limit_order", "market_order"],
                        orderTypeControls: normalizeOrderTypeControls(data?.orderTypeControls),
                    }));
                }
            })
            .catch((e) => {});
    };

    const enabledColumn = {
        key: "__enabled",
        title: "Status",
        render: (_, row) => {
            const enabled = row?.isEnabled !== false;
            const loading = isEnabledLoadingId === row?._id;
            return (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <button
                        onClick={() => handleToggleIsEnabled(row)}
                        disabled={loading}
                        title={enabled ? "Click to disable" : "Click to enable"}
                        style={{
                            position: "relative",
                            display: "inline-flex",
                            alignItems: "center",
                            width: 40,
                            height: 22,
                            borderRadius: 11,
                            border: "none",
                            cursor: loading ? "not-allowed" : "pointer",
                            backgroundColor: enabled ? "#16a34a" : "#d1d5db",
                            transition: "background-color 0.2s",
                            padding: 0,
                            flexShrink: 0,
                            opacity: loading ? 0.6 : 1,
                        }}
                    >
                        <span style={{
                            position: "absolute",
                            left: enabled ? 20 : 2,
                            width: 18,
                            height: 18,
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                            transition: "left 0.2s",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                        }} />
                    </button>
                    <span style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: enabled ? "#15803d" : "#6b7280",
                    }}>
                        {loading ? "…" : enabled ? "Active" : "Inactive"}
                    </span>
                </div>
            );
        },
    };

    const actionColumn = {
        key: "__action",
        title: "Action",
        className: "text-end",
        render: (_, row) => (
            <div className="text-end">
                <Button
                    onClick={(e) => handleMenuOpen(e, row)}
                    style={{ minWidth: 0, padding: 6 }}
                >
                    <HiDotsVertical size={18} />
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={menuOpen && id?._id === row?._id}
                    onClose={handleMenuClose}
                    PaperProps={{
                        elevation: 4,
                        sx: { borderRadius: 2, mt: 1, boxShadow: "0px 4px 16px rgba(0,0,0,0.1)", minWidth: 170 },
                    }}
                >
                    <MenuItem
                        onClick={() => {
                            handleMenuClose();
                            history.push(`/admin/trading-pair-detail/${row?._id}`);
                        }}
                        sx={{ fontSize: 14 }}
                    >
                        View Details
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            handleMenuClose();
                            setEdit(true);
                            setUser(true);
                            setId(row);
                            setroleInput({
                                ...roleInput,
                                fromCoin: row?.fromCoin?._id,
                                toCoin: row?.toCoin?._id,
                                currentPrice: row?.currentPrice,
                                minTradeAmount: row?.minTradeAmount,
                                maxTradeAmount: row?.maxTradeAmount,
                                basePrecision: row?.basePrecision ?? "",
                                targetPrecision: row?.targetPrecision ?? "",
                                minNotional: row?.minNotional ?? "",
                                stepSize: row?.stepSize ?? "",
                                priceSpread: row?.priceSpread ?? "",
                                isEnabled: row?.isEnabled !== false,
                                precisionManualOverride: !!row?.precisionManualOverride,
                                resyncFromCoinDcx: false,
                                precisionLastSyncedAt: row?.precisionLastSyncedAt ?? null,
                                pairCategory:
                                    row?.pairCategoryData
                                        ?.map((c) => typeof c === "object" ? c?._id : c)
                                        .filter(Boolean) || [],
                                type: row?.type || "coindcx",
                                orderTypes: row?.orderTypes?.length ? row.orderTypes : ["limit_order", "market_order"],
                                orderTypeControls: normalizeOrderTypeControls(row?.orderTypeControls),
                            });
                            if (row?._id) getUserDataById(row._id);
                        }}
                        sx={{ fontSize: 14 }}
                    >
                        Edit
                    </MenuItem>
                    {/* {row?.status === 0 ? (
                        <MenuItem
                            onClick={() => {
                                handleMenuClose();
                                setPendingStatus({ id: row?._id, status: 1 });
                                setOpenStatusConfirm(true);
                            }}
                            sx={{ fontSize: 14, color: "#16a34a" }}
                        >
                            Enable Trading
                        </MenuItem>
                    ) : row?.status === 1 ? (
                        <MenuItem
                            onClick={() => {
                                handleMenuClose();
                                setPendingStatus({ id: row?._id, status: 0 });
                                setOpenStatusConfirm(true);
                            }}
                            sx={{ fontSize: 14, color: "#d97706" }}
                        >
                            Disable Trading
                        </MenuItem>
                    ) : null} */}
                    <MenuItem
                        disabled={stopBuyLoadingId === row?._id}
                        onClick={() => { handleMenuClose(); handleToggleStopBuy(row); }}
                        sx={{ fontSize: 14, color: row?.stopBuy ? "#16a34a" : "#d97706" }}
                    >
                        {row?.stopBuy ? "Resume Buy" : "Stop Buy"}
                    </MenuItem>
                    <MenuItem
                        disabled={stopSellLoadingId === row?._id}
                        onClick={() => { handleMenuClose(); handleToggleStopSell(row); }}
                        sx={{ fontSize: 14, color: row?.stopSell ? "#16a34a" : "#d97706" }}
                    >
                        {row?.stopSell ? "Resume Sell" : "Stop Sell"}
                    </MenuItem>
                    <MenuItem
                        disabled={stopAllLoadingId === row?._id}
                        onClick={() => { handleMenuClose(); handleToggleStopAll(row); }}
                        sx={{ fontSize: 14, color: (row?.stopBuy && row?.stopSell) ? "#16a34a" : "#7c3aed" }}
                    >
                        {(row?.stopBuy && row?.stopSell) ? "Resume Buy/Sell" : "Stop Buy/Sell"}
                    </MenuItem>

                    {/* Internal matching — regular (CoinDCX/KuCoin) pairs only; custom-token pairs are always internal. */}
                    {row?.type !== "custom" ? (
                        <MenuItem
                            disabled={internalizationLoadingId === row?._id}
                            onClick={() => { handleMenuClose(); handleToggleInternalization(row); }}
                            sx={{ fontSize: 14, color: row?.internalizationEnabled ? "#d97706" : "#16a34a" }}
                        >
                            {row?.internalizationEnabled ? "Disable Internal Matching" : "Enable Internal Matching"}
                        </MenuItem>
                    ) : null}

                    <MenuItem
                        onClick={() => {
                            handleMenuClose();
                            handleOpenDelete();
                        }}
                        sx={{ fontSize: 14, color: "#dc2626" }}
                    >
                        Delete
                    </MenuItem>
                </Menu>
            </div>
        ),
    };

    const columns2 = [...dynamicColumns, enabledColumn, actionColumn];

    const fromCoinOptions =
        coinList?.map((c) => ({
            value: c?._id,
            label: `${c?.name}${c?.symbol ? ` (${c?.symbol})` : ""}`,
        })) || [];
    const toCoinOptions = fromCoinOptions;
    const categoryFormOptions =
        categoryList?.map((c) => ({ value: c?._id, label: c?.name })) || [];

    const fromCoinSymbol = (
        coinList?.find((c) => c?._id === roleInput?.fromCoin)?.symbol || ""
    ).toUpperCase();
    const toCoinSymbol = (
        coinList?.find((c) => c?._id === roleInput?.toCoin)?.symbol || ""
    ).toUpperCase();
    const baseLabel = toCoinSymbol || "quote currency";
    const quantityLabel = fromCoinSymbol || "base asset";
    const categoryOptions =
        categoryList?.map((c) => ({
            value: c?._id,
            label: c?.name,
        })) || [];
    const handleDateRangeChange = (event, picker) => {
        setStartDate(picker.startDate.format("YYYY-MM-DD"));
        setEndDate(picker.endDate.format("YYYY-MM-DD"));
    };
    return (
        <>
            <SidebarNav />
            <div className="page-wrapper">
                <div className="content container-fluid">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-7 col-aut0">
                                <h3 className="page-title">Trading Pair</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/admin">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Trading Pair
                                    </li>
                                </ul>
                            </div>
                            {!user && (
                                <div className="col-sm-5 col" style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary mt-2"
                                        disabled={syncLoading}
                                        onClick={() => {
                                            setSyncLoading(true);
                                            syncCoindcxPrecision()
                                                .then((res) => {
                                                    if (res?.status) {
                                                        const d = res?.data || {};
                                                        toast.success(
                                                            `Sync done — matched ${d.matched ?? 0}, updated ${d.updated ?? 0}, skipped(admin) ${d.skippedManual ?? 0}, unmatched ${d.unmatched ?? 0}`,
                                                            { toastId: 'trading-pair-sync-success' },
                                                        );
                                                        getUserList();
                                                    } else {
                                                        toast.error(res?.message || "Sync failed", { toastId: 'trading-pair-sync-error' });
                                                    }
                                                })
                                                .catch((e) =>
                                                    toast.error(e?.response?.data?.message || "Sync failed", { toastId: 'trading-pair-sync-error' }),
                                                )
                                                .finally(() => setSyncLoading(false));
                                        }}
                                    >
                                        {syncLoading ? "Syncing…" : "Sync from CoinDCX"}
                                    </button>
                                    <a
                                        onClick={() => {
                                            handleClear(),
                                                setEdit(false),
                                                setUser(true);
                                        }}
                                        data-bs-toggle="modal"
                                        className="btn btn-primary mt-2"
                                    >
                                        Add Trading Pair
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* /Page Header */}
                    <div className="row">
                        <div className="col-sm-12">
                            {user ? (
                                <div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "10px 0px",
                                            gap: "10px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "10px",
                                            }}
                                        >
                                            <FaArrowLeft
                                                style={{
                                                    marginTop: "3px",
                                                    cursor: "pointer",
                                                    width: "30px",
                                                    height: "20px",
                                                }}
                                                onClick={() => {
                                                    setEdit(false),
                                                        setUser(false);
                                                }}
                                            />
                                            <h4>
                                                {edit
                                                    ? "Edit Trading Pair"
                                                    : "Add Trading Pair"}
                                            </h4>
                                        </div>{" "}
                                        <div
                                            style={{
                                                // borderTop: "1px solid grey",
                                                height: "56px",
                                                display: "flex",
                                                justifyContent: "end",
                                                // marginTop: "30px",
                                            }}
                                        >
                                            <button
                                                className="btn btn-primary"
                                                onClick={addUserFun}
                                                disabled={loading}
                                                style={{
                                                    marginBottom: "10px",
                                                    marginTop: "9px",
                                                }}
                                            >
                                                {loading ? (
                                                    <Spinner size="sm" />
                                                ) : edit ? (
                                                    "Update"
                                                ) : (
                                                    "Add"
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                    <div
                                        style={{ margin: "10px" }}
                                        className="page-grid"
                                    >
                                        {/* <div>
                     
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="66e5f1cc2c5a6aba87411758"
                        value={roleInput?.fromCoin}
                        onChange={roleChange}
                        name="fromCoin"
                        id="fromCoin"
                      />
                    </div> */}
                                        {/* Pair Type selector */}
                                        {!edit && (
                                            <div>
                                                <InputLabel style={{ marginLeft: "7px" }}>Pair Type</InputLabel>
                                                <select
                                                    className="form-control"
                                                    style={{ marginLeft: "5px", height: 40, borderRadius: 4, border: "1px solid #ccc", paddingLeft: 8 }}
                                                    value={roleInput?.type || "coindcx"}
                                                    onChange={(e) => setroleInput({ ...roleInput, type: e.target.value })}
                                                >
                                                    <option value="coindcx">CoinDCX (INR pairs)</option>
                                                    <option value="kucoin">KuCoin (USDT pairs)</option>
                                                    <option value="custom">Custom Token</option>
                                                </select>
                                            </div>
                                        )}

                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                From Coin
                                                <InfoIcon title="The asset being bought/sold (e.g., BTC in BTC/USDT). All quantity-based fields (Min/Max Trade Amount, Step Size, Target Currency Precision) are expressed in this currency." />
                                                &nbsp;
                                                {roleInputError?.fromCoin && (
                                                    <small style={{ color: "red" }}>
                                                        {"From Coin is required"}
                                                    </small>
                                                )}
                                            </InputLabel>
                                            <ReactSelect
                                                options={fromCoinOptions}
                                                value={
                                                    fromCoinOptions.find(
                                                        (o) => o.value === roleInput?.fromCoin,
                                                    ) || null
                                                }
                                                onChange={(option) => {
                                                    setroleInput({
                                                        ...roleInput,
                                                        fromCoin: option?.value || "",
                                                    });
                                                    setroleInputError({
                                                        ...roleInputError,
                                                        fromCoin: false,
                                                    });
                                                }}
                                                placeholder="Search and select coin"
                                                isSearchable
                                                isClearable
                                            />
                                        </div>
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                To Coin
                                                <InfoIcon title="The quote/pricing currency (e.g., USDT in BTC/USDT). All value-based fields (Min Notional, price precision via Base Currency Precision) are expressed in this currency." />
                                                &nbsp;
                                                {roleInputError?.toCoin && (
                                                    <small style={{ color: "red" }}>
                                                        {"To Coin is required"}
                                                    </small>
                                                )}
                                            </InputLabel>
                                            <ReactSelect
                                                options={toCoinOptions}
                                                value={
                                                    toCoinOptions.find(
                                                        (o) => o.value === roleInput?.toCoin,
                                                    ) || null
                                                }
                                                onChange={(option) => {
                                                    setroleInput({
                                                        ...roleInput,
                                                        toCoin: option?.value || "",
                                                    });
                                                    setroleInputError({
                                                        ...roleInputError,
                                                        toCoin: false,
                                                    });
                                                }}
                                                placeholder="Search and select coin"
                                                isSearchable
                                                isClearable
                                            />
                                        </div>
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                Category &nbsp;
                                                {roleInputError?.pairCategory && (
                                                    <small style={{ color: "red" }}>
                                                        {"Category is required"}
                                                    </small>
                                                )}
                                            </InputLabel>
                                            <ReactSelect
                                                isMulti
                                                options={categoryFormOptions}
                                                value={categoryFormOptions.filter((o) =>
                                                    (roleInput?.pairCategory || []).includes(o.value),
                                                )}
                                                onChange={(options) => {
                                                    setroleInput({
                                                        ...roleInput,
                                                        pairCategory: (options || []).map(
                                                            (o) => o.value,
                                                        ),
                                                    });
                                                    setroleInputError({
                                                        ...roleInputError,
                                                        pairCategory: false,
                                                    });
                                                }}
                                                placeholder="Search and select category"
                                                isSearchable
                                            />
                                        </div>
                                        <div>
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                style={{ marginLeft: "7px" }}
                                            >
                                                {roleInput?.type === "custom" ? "Initial Price" : "Current Price"} &nbsp;
                                                {priceLoading && (
                                                    <small style={{ color: "#888" }}>
                                                        fetching live price…
                                                    </small>
                                                )}
                                                {roleInputError?.currentPrice && (
                                                    <small
                                                        style={{ color: "red" }}
                                                    >
                                                        {"Price is required"}
                                                    </small>
                                                )}
                                            </InputLabel>
                                            <TextField
                                                variant="outlined"
                                                style={{
                                                    // width: "370px",
                                                    marginLeft: "5px",
                                                    height: "100%",
                                                }}
                                                className="form-control"
                                                type="number"
                                                placeholder="Current Price"
                                                value={roleInput?.currentPrice}
                                                onChange={roleChange}
                                                name="currentPrice"
                                                id="currentPrice"
                                                inputProps={{ min: 0 }}
                                                onKeyDown={(e) => {
                                                    if (
                                                        e.key === "-" ||
                                                        e.key === "+" ||
                                                        e.key === "e" ||
                                                        e.key === "E"
                                                    ) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>

                                        {/* Min Trade Amount */}
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                Min Trade Amount
                                                <small style={{ marginLeft: 6, color: "#666" }}>
                                                    {quantityLabel ? `(in ${quantityLabel})` : ""}
                                                </small>
                                                <InfoIcon
                                                    title={`Minimum quantity allowed per order, expressed in the From Coin (${quantityLabel}). Example: for ${quantityLabel}/${baseLabel}, this is the smallest amount of ${quantityLabel} a user can buy/sell.`}
                                                />
                                            </InputLabel>
                                            <TextField
                                                variant="outlined"
                                                style={{ marginLeft: "5px", height: "100%" }}
                                                className="form-control"
                                                type="number"
                                                placeholder={`e.g. 0.0001 ${quantityLabel || ""}`.trim()}
                                                value={roleInput?.minTradeAmount}
                                                onChange={roleChange}
                                                name="minTradeAmount"
                                                id="minTradeAmount"
                                                inputProps={{ min: 0 }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E") e.preventDefault();
                                                }}
                                            />
                                        </div>

                                        {/* Max Trade Amount */}
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                Max Trade Amount
                                                <small style={{ marginLeft: 6, color: "#666" }}>
                                                    {quantityLabel ? `(in ${quantityLabel})` : ""}
                                                </small>
                                                <InfoIcon
                                                    title={`Maximum quantity allowed per order, expressed in the From Coin (${quantityLabel}). Example: for ${quantityLabel}/${baseLabel}, this is the largest amount of ${quantityLabel} a user can buy/sell in a single order.`}
                                                />
                                            </InputLabel>
                                            <TextField
                                                variant="outlined"
                                                style={{ marginLeft: "5px", height: "100%" }}
                                                className="form-control"
                                                type="number"
                                                placeholder={`e.g. 1000 ${quantityLabel || ""}`.trim()}
                                                value={roleInput?.maxTradeAmount}
                                                onChange={roleChange}
                                                name="maxTradeAmount"
                                                id="maxTradeAmount"
                                                inputProps={{ min: 0 }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E") e.preventDefault();
                                                }}
                                            />
                                        </div>

                                        {/* Base Currency Precision */}
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                Base Currency Precision
                                                <small style={{ marginLeft: 6, color: "#666" }}>
                                                    {baseLabel ? `(price decimals — ${baseLabel})` : ""}
                                                </small>
                                                <InfoIcon
                                                    title={`Number of decimal places allowed for the order price (in the To Coin / quote currency, ${baseLabel}). Example: precision 2 means price 81307.60 is valid; 81307.604 is not.`}
                                                />
                                            </InputLabel>
                                            <TextField
                                                variant="outlined"
                                                style={{ marginLeft: "5px", height: "100%" }}
                                                className="form-control"
                                                type="number"
                                                placeholder="e.g. 8"
                                                value={roleInput?.basePrecision}
                                                onChange={roleChange}
                                                name="basePrecision"
                                                id="basePrecision"
                                                inputProps={{ min: 0, max: 18 }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E" || e.key === ".") e.preventDefault();
                                                }}
                                            />
                                        </div>

                                        {/* Target Currency Precision */}
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                Target Currency Precision
                                                <small style={{ marginLeft: 6, color: "#666" }}>
                                                    {quantityLabel ? `(quantity decimals — ${quantityLabel})` : ""}
                                                </small>
                                                <InfoIcon
                                                    title={`Number of decimal places allowed for the order quantity (in the From Coin / asset, ${quantityLabel}). Example: precision 4 means 0.1234 ${quantityLabel} is valid; 0.12345 is not.`}
                                                />
                                            </InputLabel>
                                            <TextField
                                                variant="outlined"
                                                style={{ marginLeft: "5px", height: "100%" }}
                                                className="form-control"
                                                type="number"
                                                placeholder="e.g. 2"
                                                value={roleInput?.targetPrecision}
                                                onChange={roleChange}
                                                name="targetPrecision"
                                                id="targetPrecision"
                                                inputProps={{ min: 0, max: 18 }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E" || e.key === ".") e.preventDefault();
                                                }}
                                            />
                                        </div>

                                        {/* Min Notional Value */}
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                Min Notional Value
                                                <small style={{ marginLeft: 6, color: "#666" }}>
                                                    {baseLabel ? `(in ${baseLabel})` : ""}
                                                </small>
                                                <InfoIcon
                                                    title={`Minimum order value, expressed in the To Coin / quote currency (${baseLabel}). It's the minimum quantity × price. Example: if min_notional = 10 ${baseLabel}, an order of 0.0001 ${quantityLabel} at 50000 ${baseLabel} = 5 ${baseLabel} would be rejected.`}
                                                />
                                            </InputLabel>
                                            <TextField
                                                variant="outlined"
                                                style={{ marginLeft: "5px", height: "100%" }}
                                                className="form-control"
                                                type="number"
                                                placeholder="e.g. 10"
                                                value={roleInput?.minNotional}
                                                onChange={roleChange}
                                                name="minNotional"
                                                id="minNotional"
                                                inputProps={{ min: 0 }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E") e.preventDefault();
                                                }}
                                            />
                                        </div>

                                        {/* Step Size / Quantity Steps */}
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                Step Size / Quantity Steps
                                                <small style={{ marginLeft: 6, color: "#666" }}>
                                                    {quantityLabel ? `(in ${quantityLabel})` : ""}
                                                </small>
                                                <InfoIcon
                                                    title={`Quantity must be an integer multiple of this step, expressed in the From Coin (${quantityLabel}). Example: step 0.00001 ${quantityLabel} → quantities 0.00001, 0.00002, … are valid; 0.000015 is not.`}
                                                />
                                            </InputLabel>
                                            <TextField
                                                variant="outlined"
                                                style={{ marginLeft: "5px", height: "100%" }}
                                                className="form-control"
                                                type="number"
                                                placeholder="e.g. 0.00001"
                                                value={roleInput?.stepSize}
                                                onChange={roleChange}
                                                name="stepSize"
                                                id="stepSize"
                                                inputProps={{ min: 0 }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E") e.preventDefault();
                                                }}
                                            />
                                        </div>

                                        {/* Price Spread — hidden for custom pairs */}
                                        {roleInput?.type !== "custom" && (
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                Price Spread (%)
                                                <InfoIcon title="Percentage spread applied to the market price shown to users. Minimum value is 0.5." />
                                                &nbsp;
                                                {roleInputError?.priceSpread && (
                                                    <small style={{ color: "red" }}>
                                                        {"Must be ≥ 0.5"}
                                                    </small>
                                                )}
                                            </InputLabel>
                                            <TextField
                                                variant="outlined"
                                                style={{ marginLeft: "5px", height: "100%" }}
                                                className="form-control"
                                                type="number"
                                                placeholder="e.g. 0.5"
                                                value={roleInput?.priceSpread}
                                                onChange={(e) => {
                                                    roleChange(e);
                                                    if (e.target.value === "" || Number(e.target.value) >= 0.5) {
                                                        setroleInputError({ ...roleInputError, priceSpread: false });
                                                    }
                                                }}
                                                name="priceSpread"
                                                id="priceSpread"
                                                inputProps={{ min: 0.5, step: 0.1 }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E") e.preventDefault();
                                                }}
                                                error={!!roleInputError?.priceSpread}
                                            />
                                        </div>
                                        )}

                                        {/* Per-order-type Buy/Sell controls — shown for all pair types */}
                                        <div style={{ marginLeft: "5px", marginTop: 14 }}>
                                            <InputLabel style={{ marginLeft: "2px" }}>
                                                Order Type Settings
                                                <InfoIcon title="Independently enable or disable Buy and Sell for each order type on this pair." />
                                            </InputLabel>
                                            <div style={{ marginTop: 8, border: "1px solid #e5e7eb", borderRadius: 6, overflow: "hidden" }}>
                                                <div style={{ display: "grid", gridTemplateColumns: "1fr 90px 90px", padding: "6px 12px", backgroundColor: "#f9fafb", fontSize: 12, fontWeight: 700, color: "#374151" }}>
                                                    <span>Order Type</span>
                                                    <span style={{ textAlign: "center" }}>Buy</span>
                                                    <span style={{ textAlign: "center" }}>Sell</span>
                                                </div>
                                                {ORDER_TYPE_DEFS.map((ot) => {
                                                    const current = roleInput?.orderTypeControls?.[ot.value] || { buy: true, sell: true };
                                                    const toggleSide = (side) => {
                                                        setroleInput({
                                                            ...roleInput,
                                                            orderTypeControls: {
                                                                ...(roleInput?.orderTypeControls || DEFAULT_ORDER_TYPE_CONTROLS),
                                                                [ot.value]: { ...current, [side]: !current[side] },
                                                            },
                                                        });
                                                    };
                                                    const renderToggle = (side) => {
                                                        const on = current[side] !== false;
                                                        return (
                                                            <button
                                                                type="button"
                                                                onClick={() => toggleSide(side)}
                                                                style={{
                                                                    position: "relative", display: "inline-block", width: 36, height: 20,
                                                                    borderRadius: 10, border: "none",
                                                                    backgroundColor: on ? "#16a34a" : "#d1d5db",
                                                                    transition: "background-color 0.2s", cursor: "pointer", padding: 0,
                                                                }}
                                                            >
                                                                <span style={{
                                                                    position: "absolute", top: 2, left: on ? 18 : 2,
                                                                    width: 16, height: 16, borderRadius: "50%",
                                                                    backgroundColor: "#fff", transition: "left 0.2s",
                                                                    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                                                }} />
                                                            </button>
                                                        );
                                                    };
                                                    return (
                                                        <div key={ot.value} style={{ display: "grid", gridTemplateColumns: "1fr 90px 90px", alignItems: "center", padding: "8px 12px", borderTop: "1px solid #f0f0f0", fontSize: 13 }}>
                                                            <span>{ot.label}</span>
                                                            <span style={{ display: "flex", justifyContent: "center" }}>{renderToggle("buy")}</span>
                                                            <span style={{ display: "flex", justifyContent: "center" }}>{renderToggle("sell")}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>


                                        {/* Enable / Disable toggle */}
                                        <div>
                                            <InputLabel style={{ marginLeft: "7px" }}>
                                                Pair Status
                                            </InputLabel>
                                            <div style={{ marginLeft: "7px", display: "inline-flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                                                <button
                                                    type="button"
                                                    onClick={() => setroleInput({ ...roleInput, isEnabled: roleInput?.isEnabled === false })}
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        width: 44,
                                                        height: 24,
                                                        borderRadius: 12,
                                                        border: "none",
                                                        backgroundColor: roleInput?.isEnabled !== false ? "#16a34a" : "#d1d5db",
                                                        transition: "background-color 0.2s",
                                                        cursor: "pointer",
                                                        padding: 0,
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    <span style={{
                                                        position: "absolute",
                                                        top: 3,
                                                        left: roleInput?.isEnabled !== false ? 22 : 3,
                                                        width: 18,
                                                        height: 18,
                                                        borderRadius: "50%",
                                                        backgroundColor: "#fff",
                                                        transition: "left 0.2s",
                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                                    }} />
                                                </button>
                                                <span style={{
                                                    fontSize: 13,
                                                    fontWeight: 600,
                                                    color: roleInput?.isEnabled !== false ? "#15803d" : "#b91c1c",
                                                }}>
                                                    {roleInput?.isEnabled !== false ? "Enabled" : "Disabled"}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Precision sync status + re-sync toggle (edit only, not for custom pairs) */}
                                        {edit && roleInput?.type !== "custom" && (
                                            <div style={{ marginLeft: "5px", marginTop: "8px" }}>
                                                <InputLabel style={{ marginLeft: "7px" }}>
                                                    Precision Source
                                                </InputLabel>
                                                <div style={{ marginLeft: "7px", fontSize: "0.85rem", color: "#666" }}>
                                                    {roleInput?.precisionManualOverride
                                                        ? "Admin override (cron will not modify these four fields)"
                                                        : "Auto-synced from CoinDCX every 6 hours"}
                                                    {roleInput?.precisionLastSyncedAt && (
                                                        <>
                                                            {" — last synced: "}
                                                            {new Date(roleInput.precisionLastSyncedAt).toLocaleString()}
                                                        </>
                                                    )}
                                                </div>
                                                {roleInput?.precisionManualOverride && (
                                                    <label style={{ marginLeft: "7px", display: "inline-flex", alignItems: "center", gap: "6px", marginTop: "6px" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={!!roleInput?.resyncFromCoinDcx}
                                                            onChange={(e) =>
                                                                setroleInput({
                                                                    ...roleInput,
                                                                    resyncFromCoinDcx: e.target.checked,
                                                                })
                                                            }
                                                        />
                                                        Re-sync from CoinDCX on save (clears manual override)
                                                    </label>
                                                )}
                                            </div>
                                        )}

                                        {/* <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Minimum Trade Amount &nbsp;
                        {roleInputError?.minTradeAmount && (
                          <small style={{ color: "red" }}>
                            {"Minimum Trade Amount is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="number"
                        placeholder="Minimum Trade Amount"
                        value={roleInput?.minTradeAmount}
                        onChange={roleChange}
                        name="minTradeAmount"
                        id="minTradeAmount"
                        inputProps={{ min: 0 }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "e" ||
                            e.key === "E"
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Maximum Trade Amount &nbsp;
                        {roleInputError?.maxTradeAmount && (
                          <small style={{ color: "red" }}>
                            {"Maximum Trade Amount is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="number"
                        placeholder="Maximum Trade Amount"
                        value={roleInput?.maxTradeAmount}
                        onChange={roleChange}
                        name="maxTradeAmount"
                        id="maxTradeAmount"
                        inputProps={{ min: 0 }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "e" ||
                            e.key === "E"
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div> */}
                                    </div>
                                </div>
                            ) : (
                                <div className="list-layout">
                                    <div className="list-layout__main">
                                        <div className="card">
                                            <div className="card-body">
                                                <TableToolbar
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    pageSizeOptions={
                                                        pageSizeOptions
                                                    }
                                                    total={userList?.total}
                                                    page={page}
                                                    visibleColumnKeys={
                                                        visibleColumnKeys
                                                    }
                                                    allColumns={ALL_COLUMNS}
                                                    toggleColumn={toggleColumn}
                                                    resetColumns={resetColumns}
                                                    onDownload={handleDownload}
                                                    downloadLoading={downloadLoading}
                                                />
                                                <div className="table-responsive">
                                                    {loading ? (
                                                        <div className="his-spin">
                                                            <Spin
                                                                size="large"
                                                                style={{
                                                                    position:
                                                                        "relative",
                                                                    top: "35%",
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <Table
                                                            pagination={false}
                                                            style={{
                                                                overflowX:
                                                                    "auto",
                                                            }}
                                                            columns={columns2}
                                                            dataSource={
                                                                userList
                                                                    ? userList?.result
                                                                    : []
                                                            }
                                                            rowKey={(record) =>
                                                                record._id ||
                                                                record.id
                                                            }
                                                        />
                                                    )}
                                                    {userList &&
                                                        userList?.total >
                                                            pageSize && (
                                                            <CustomPagination
                                                                key={`pg-${pageSize}`}
                                                                totalTabs={
                                                                    userList?.total
                                                                }
                                                                tabsPerPage={
                                                                    pageSize
                                                                }
                                                                handleChange={
                                                                    setPage
                                                                }
                                                                className={`${
                                                                    loading
                                                                        ? "display-hide"
                                                                        : "display-flex"
                                                                }`}
                                                            />
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="list-layout__filters">
                                        <FilterPanel
                                            count={userList?.total}
                                            onClear={() => {
                                                setSearchTerm("");
                                                setFilterFromCoin(null);
                                                setFilterToCoin(null);
                                                setFilterCategory(null);
                                                setFilterIsEnabled(null);
                                                setStartDate();
                                                setEndDate();
                                            }}
                                        >
                                            <FilterPanel.Field label="Search">
                                                <input
                                                    type="text"
                                                    placeholder="Symbol or name"
                                                    value={searchTerm}
                                                    onChange={(e) =>
                                                        setSearchTerm(
                                                            sanitizeInput(
                                                                e.target.value,
                                                            ),
                                                        )
                                                    }
                                                />
                                            </FilterPanel.Field>
                                            <FilterPanel.Field label="From Coin">
                                                <ReactSelect
                                                    options={fromCoinOptions}
                                                    value={
                                                        filterFromCoin || null
                                                    }
                                                    onChange={(option) =>
                                                        setFilterFromCoin(
                                                            option,
                                                        )
                                                    }
                                                    styles={customStyles}
                                                    placeholder="Any"
                                                    isSearchable={false}
                                                    isClearable
                                                />
                                            </FilterPanel.Field>
                                            <FilterPanel.Field label="To Coin">
                                                <ReactSelect
                                                    options={toCoinOptions}
                                                    value={filterToCoin || null}
                                                    onChange={(option) =>
                                                        setFilterToCoin(option)
                                                    }
                                                    styles={customStyles}
                                                    placeholder="Any"
                                                    isSearchable={false}
                                                    isClearable
                                                />
                                            </FilterPanel.Field>
                                            <FilterPanel.Field label="Category">
                                                <ReactSelect
                                                    options={categoryOptions}
                                                    value={
                                                        filterCategory || null
                                                    }
                                                    onChange={(option) =>
                                                        setFilterCategory(
                                                            option,
                                                        )
                                                    }
                                                    styles={customStyles}
                                                    placeholder="Any"
                                                    isSearchable={false}
                                                    isClearable
                                                />
                                            </FilterPanel.Field>
                                            <FilterPanel.Field label="Pair Status">
                                                <ReactSelect
                                                    options={[
                                                        { value: "true",  label: "Enabled" },
                                                        { value: "false", label: "Disabled" },
                                                    ]}
                                                    value={filterIsEnabled || null}
                                                    onChange={(option) => setFilterIsEnabled(option)}
                                                    styles={customStyles}
                                                    placeholder="Any"
                                                    isSearchable={false}
                                                    isClearable
                                                />
                                            </FilterPanel.Field>
                                        </FilterPanel>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        open={openDelete}
                        onClose={handleCloseDelete}
                        closeAfterTransition
                        slots={{ backdrop: backdrop }}
                        slotProps={{
                            backdrop: {
                                timeout: 500,
                            },
                        }}
                    >
                        <Fade in={openDelete}>
                            <Box style={styleDelete}>
                                <div
                                    style={{
                                        margin: "10px",
                                        textAlign: "center",
                                    }}
                                >
                                    Please confirm before deleting
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <button
                                        className="btn btn-danger"
                                        disabled={loading}
                                        onClick={handleDeleteFunction}
                                        style={{
                                            marginBottom: "10px",
                                            marginTop: "15px",
                                        }}
                                    >
                                        {loading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            "Delete"
                                        )}
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleCloseDelete}
                                        style={{
                                            marginLeft: "7px",
                                            marginBottom: "10px",
                                            marginTop: "15px",
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Box>
                        </Fade>
                    </Modal>

                    {/* Enable / Disable trading pair confirmation modal */}
                    <Modal
                        open={openStatusConfirm}
                        onClose={() => { setOpenStatusConfirm(false); setPendingStatus(null); }}
                        closeAfterTransition
                    >
                        <Fade in={openStatusConfirm}>
                            <Box style={styleDelete}>
                                <div style={{ margin: "10px", textAlign: "center", fontWeight: 600 }}>
                                    {pendingStatus?.status === 1
                                        ? "Enable trading for this pair?"
                                        : "Disable trading for this pair?"}
                                </div>
                                <p style={{ textAlign: "center", fontSize: "12px", color: "#666", margin: "0 10px 10px" }}>
                                    {pendingStatus?.status === 1
                                        ? "Users will be able to trade this pair once enabled."
                                        : "Users will not be able to place new orders for this pair."}
                                </p>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <button
                                        className={`btn ${pendingStatus?.status === 1 ? "btn-success" : "btn-warning"}`}
                                        disabled={statusLoading}
                                        onClick={handleStatusConfirm}
                                        style={{ marginBottom: "10px", marginTop: "15px" }}
                                    >
                                        {statusLoading ? <Spinner size="sm" /> : pendingStatus?.status === 1 ? "Enable" : "Disable"}
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => { setOpenStatusConfirm(false); setPendingStatus(null); }}
                                        style={{ marginLeft: "7px", marginBottom: "10px", marginTop: "15px" }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Box>
                        </Fade>
                    </Modal>
                </div>
            </div>

        </>
    );
};

export default TradingPair;
